import React, { useEffect, useState } from "react";
import { useGameStore } from "../../store/useGameStore";

const SportsIframe = () => {
  const iframeUrl = useGameStore((s) => s.iframeUrl);
  const isSports = useGameStore((s) => s.isSports);
  const closeGame = useGameStore((s) => s.closeGame);
  const [loading, setIsLoading] = useState(true);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    if (iframeUrl && isSports) {
      setIsLoading(true);
      setIframeLoaded(false);
      const timer = setTimeout(() => setIsLoading(false), 3000);
      return () => clearTimeout(timer);
    } else {
      setIsLoading(true);
      setIframeLoaded(false);
    }
  }, [iframeUrl, isSports]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!iframeUrl || !isSports) return null;

  const handleClose = () => {
    closeGame();
    window.location.reload(false);
  };

  return (
    <>
      {loading ? (
        <div style={{
          position: "fixed", top: 0, left: 0,
          width: "100vw", height: "100vh",
          background: "#1a1a1a", display: "flex",
          justifyContent: "center", alignItems: "center", zIndex: 10000,
        }}>
          <div style={{
            width: 60, height: 60,
            border: "5px solid #FFB606", borderTop: "5px solid transparent",
            borderRadius: "50%", animation: "spin 1s linear infinite",
          }} />
        </div>
      ) : (
        <div style={{
          position: "fixed", top: 0, left: 0,
          width: "100vw", height: "100vh",
          zIndex: 9999, overflow: "hidden",
        }}>
          {iframeLoaded && (
            <div
              onClick={handleClose}
              style={{
                position: "absolute",
                top: 13,
                left: 14,
                zIndex: 10000,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                background: "rgb(255, 182, 6)",
                padding: "21px 29px",
                borderRadius: 4,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28" height="28" viewBox="0 0 24 24"
                fill="none" stroke="black" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round"
              >
                <path d="M19 12H5" />
                <path d="M12 19l-7-7 7-7" />
              </svg>
            </div>
          )}
          <iframe
            src={iframeUrl}
            onLoad={() => setIframeLoaded(true)}
            style={{
              position: "absolute", top: 0, left: 0,
              width: "100%", height: "100%",
              border: "none", margin: 0, padding: 0, overflow: "hidden",
            }}
            allowFullScreen
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          />
        </div>
      )}
    </>
  );
};

export default SportsIframe;
